import React from 'react';
import { useLocation } from 'react-router-dom';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faFaucet,
  faTemperatureHalf,
  faSeedling,
  faSnowflake
} from '@fortawesome/free-solid-svg-icons';

import '../../styles/styles.scss';

/* Fonction Card */

function Card({ serviceName, serviceLink, imageUrl }) {

  const location = useLocation();

  const isNotreSavoirFairePage =
    location.pathname === '/notre-savoir-faire';

  const altText =
    `${serviceName} à Thonon-les-Bains, Allinges et dans le Chablais`;

  const getIcon = () => {
    switch (serviceName) {
      case 'Plomberie':
        return faFaucet;

      case 'Chauffage':
        return faTemperatureHalf;

      case 'Pompe à chaleur':
        return faSeedling;

      case 'Climatisation':
        return faSnowflake;

      default:
        return faFaucet;
    }
  };

  return (
    <Link to={serviceLink} className="card-link">

      <div className="card">

        <span className="card-span">

          {isNotreSavoirFairePage ? (
            <FontAwesomeIcon icon={getIcon()} />
          ) : (
            <img
              className="card__image"
              src={imageUrl}
              alt={altText}
            />
          )}

        </span>

        <div className="card__content">
          <h3>{serviceName}</h3>
          <p>+ d'info</p>
        </div>

      </div>

    </Link>
  );
}

export default Card;